import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NgxActivityTaskSessionsComponent } from './activity-task-sessions.component';
import { ActivityTaskEditModeGuard } from '@go-modules/guards/activity-task-edit-mode/activity-task-edit-mode-guard';

const routes: Routes = [
	{
		path: '',
		component: NgxActivityTaskSessionsComponent,
		canDeactivate: [ActivityTaskEditModeGuard]
	}
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class ActivityTaskSessionsRoutingModule {}
